<template>
<div class="chapter">
<div class="inner_page">
<p class="titlea">CarCraft 3</p>
<h1 class="title">JAGUAR E-TYPE</h1>
<p class="sub-title">BRITISH MOTORING MASTERPIECE</p>
<p class="author">Lance Cole</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Title.vue?1fe781f6